/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The tooltip content of the icon, displays the given value, or the current value of the ref, or both if both are provided.
 */
export type IconTooltipContent = {
  /**
   * A reference to a reading or setting.
   */
  ref?: Ref | undefined;
  /**
   * The content of the tooltip
   */
  value?: string | undefined;
};

/** @internal */
export const IconTooltipContent$inboundSchema: z.ZodType<
  IconTooltipContent,
  z.ZodTypeDef,
  unknown
> = z.object({
  ref: types.optional(Ref$inboundSchema),
  value: types.optional(types.string()),
});
/** @internal */
export type IconTooltipContent$Outbound = {
  ref?: Ref$Outbound | undefined;
  value?: string | undefined;
};

/** @internal */
export const IconTooltipContent$outboundSchema: z.ZodType<
  IconTooltipContent$Outbound,
  z.ZodTypeDef,
  IconTooltipContent
> = z.object({
  ref: Ref$outboundSchema.optional(),
  value: z.string().optional(),
});

export function iconTooltipContentToJSON(
  iconTooltipContent: IconTooltipContent,
): string {
  return JSON.stringify(
    IconTooltipContent$outboundSchema.parse(iconTooltipContent),
  );
}
export function iconTooltipContentFromJSON(
  jsonString: string,
): SafeParseResult<IconTooltipContent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IconTooltipContent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IconTooltipContent' from JSON`,
  );
}
